(function () {
  var tracksSlide = () => {
    var $slickElement = $('.section-tracks__slider').not('.slick-initialized');

    $slickElement.one('mouseenter focusin touchstart', function () {
      $(this).find('.section-tracks__slide.hover').removeClass('hover');
    });

    $slickElement.slick({
      slidesToShow: 4,
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots section-tracks__dots',
      adaptiveHeight: true,
      infinite: false,
      swipeToSlide: true,
      touchThreshold: 12,
      waitForAnimate: false,
      speed: 500,
      cssEase: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      responsive: [
        {
          breakpoint: 1330,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

  }

  document.addEventListener('shopify:section:load', function () {
    tracksSlide();
  });

  tracksSlide();

})();